module.exports = __webpack_public_path__ + "img/CurrencyConverterLogo.5ba6db81.png";